import React from "react";

export default function ContactScreen() {
  return (
    <div id="top">
      
      <section className="flex-col  space-y-16 my-48   mt-28 m-auto mb-16 " >
      
      <h1 className="font-bold text-center ">Nos Horaires</h1>
      <h2 className="text-center text-7xl  ">Tous les lundis soirs</h2>
      
       
        <div className="flex-col md:flex-row lg:flex-row space-y-4 m-auto justify-center items-center md:justify-center md:items-center lg:justify-center lg:items-center   md:space-x-8  text-center">
        
          
            <div></div>
       
            <button className=" m-auto text-center w-4/6 lg:w-1/3 shadow p-4 hover:shadow-lg rounded ">
              <div className="flex-col justify-center  items-center m-auto">
                <h1 className="">Lady Style</h1>
                <h2 className="">20 h 15 - 21 h 15</h2>
              </div>
            </button>
           

            <button className="m-auto shadow text-center p-4 hover:shadow-lg rounded w-4/6 lg:w-1/3 ">
              <div className="flex-col justify-center items-center">
                <h1 className="text-amber-600">Danse de salon</h1>
                <h2 className="">19 h 15 - 20 h 00</h2>
              </div>
            </button>
          
        
        </div>

      <div className="flex flex-wrap items-center justify-center">
        <img src=" img/warning.png" alt="" />
        <p className="text-center  px-4">
          Attention les horaires sont susceptibles de changer veuillez prendre
          contact pour vous en assurer.
        </p>
      </div>
      </section>


      <section>
      <div className="m-auto">
            <button className=" flex  w-5/6 m-auto justify-center text-center p-4  rounded">
              <div className="flex-col justify-center  m-auto items-center">
                <h2 className="">
                  <img src="../../img/house.png" alt="" className="m-auto text-center" />
                </h2>
                <h1 className="text-teal-700">Salle des fêtes de Neuvilly !</h1>
                <h2>Place du commerce, 59360 Neuvilly.</h2>
              </div>
            </button>
        <iframe
          title="plan"
          className="m-auto md:w-4/6 w-5/6"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2557.035201915557!2d3.5094015769179214!3d50.141773309540795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c29117fab43bc9%3A0x86e891711d926ba1!2sSalle%20des%20f%C3%AAtes%20de%20Neuvilly!5e0!3m2!1sfr!2sfr!4v1728936056116!5m2!1sfr!2sfr"
          height="400"
          width="auto"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      {/* <div className='flex-col flex-wrap   w-1/2 justify-center  m-auto space-x-8'> */}
      <div className="flex-col md:flex md:flex-wrap justify-center items-center  space-y-12 my-28   ">
        <div className=" flex-col mg:flex  mg:justify-center mg:items-center w-5/6 mg:w-3/6 lg:w-2/6 mg:space-y-8 lg:space-y-8 ">
          <h2 className="font-bold  m-auto text-center ms-14  ">
            Nous contacter
          </h2>

          <div className="flex-col justify-center items-center  m-auto space-x-8  space-y-2">
            <br />

            <button  className="shadow w-full m-auto text-center w-1/2 p-4 hover:shadow-lg rounded">
            <a href="mailto:danse.de.salon.neuvilly@gmail.com">
              <div className="flex-col justify-center items-center">
                <h1 className="">
                  <img src="../../img/mail.svg" alt="" className="m-auto" />
                </h1>
                <h2 className=" ">
                  danse.de.salon.neuvilly<br />@gmail.com
                </h2>
              </div>
              </a>
            </button>
            <br />

            <button className="shadow w-full text-center p-4 hover:shadow-lg w-5/6 rounded ">
            <a href="tel:+33603755840">
              <div className="flex-col md:flex lg:flex">
                <h1 className="text-amber-600 whitespace-nowrap">Keren-Or</h1>
                <h2 className="text-teal-700 whitespace-nowrap">06   03   75   58  40</h2>
              </div>
            </a>
            </button>
            <button className="shadow w-full text-center p-4 hover:shadow-lg  w-1/2 rounded ">
            <a href="tel:+33609573277">
              <div className="flex-col">
                <h1 className="text-amber-600">Michel</h1>
                <h2 className="text-teal-700 whitespace-nowrap">06   09   57   32   77</h2>
              </div>
              </a>
            </button>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}
